import { CopyAll } from '@mui/icons-material';
import { Box, Grid, Paper, styled } from '@mui/material';
import { ReactEventHandler } from 'react';
import {
  WsColors,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  WsButton,
  theme,
} from 'wisestep-base';

interface BooleanQryCardProps {
  title: string;
  onclick?: ReactEventHandler;
  description: string;
}
const HeaderTheme = styled(Grid)(() => ({
  borderRadius: 1,
  backgroundColor: WsColors.TertiaryShades50,
  padding: theme.spacing(1),
  justifyContent: 'space-between',
  xs: 12,
}));
export default function BooleanQryCard({ title, description, onclick }: BooleanQryCardProps) {
  return (
    <Paper variant="outlined" sx={{ borderRadius: 1 }}>
      <HeaderTheme container>
        <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.BLACK}>
          {title}
        </WsTypography>
        <WsButton variant="text" size="small" startIcon={<CopyAll />} onClick={onclick}>
          Copy
        </WsButton>
      </HeaderTheme>
      <Box p={1}>
        <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK}>
          {description}
        </WsTypography>
      </Box>
    </Paper>
  );
}
